import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { Row } from "react-bootstrap";
import PropTypes from "prop-types";
import usePermissions from "hooks/usePermissions";
import CommonSettingsNav from "./components/CommonSettingsNav/CommonSettingsNav";

const SettingsWrapper = forwardRef(({ children }, ref) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const { permissions, setPermissions } = usePermissions();

  useImperativeHandle(ref, () => ({ setPermissions }), []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Row>
      <CommonSettingsNav permissions={permissions} />
      <div className="w-100" style={{ paddingLeft: !isMobile ? "245px" : "40px", paddingRight: "24px" }}>
        {children}
      </div>
    </Row>
  );
});

SettingsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SettingsWrapper;
